import { Link } from 'gatsby';
import React,{useEffect, useRef} from 'react';
import scrollTo from 'gatsby-plugin-smoothscroll';
import './menuScroll.scss';

const MenuScroll = () => {


    const menuScrollRef = useRef(null);

    useEffect(() => {
        document.addEventListener('scroll',(e)=>{
            let lastYpos = window.scrollY;
            if(lastYpos > 500){
                menuScrollRef.current.classList.add('visible')
            }else if(lastYpos < 300){
                menuScrollRef.current.classList.remove('visible')
            }
       });
    }, [])

    return (
        <div ref={menuScrollRef} className="scroll-menu">
            <ul className="scroll-menu__container">
                <Link to='/' className="scroll-menu__item" tabIndex="0" >Home</Link>
                <li className="scroll-menu__item"  >
                    <a role="button" tabIndex="0" onClick={() => scrollTo('#technologies')}>Technologies</a>
                </li>
                <li className="scroll-menu__item" >
                    <a role="button" tabIndex="0" onClick={() => scrollTo('#projects')} >Projects</a>
                </li>
                <li className="scroll-menu__item" >
                   <a role="button" tabIndex="0" onClick={() => scrollTo('#contact')} >Contact</a>
                </li>
            </ul>
        </div>
    )
}

export default MenuScroll
